import React, { createContext, useState } from "react";

// notesChanged can be: false | 'add' | 'edit' | 'delete'
export const NoteContext = createContext({
  notesChanged: false,
  setNotesChanged: () => {},
  resetNotesChanged: () => {},
});

export const NoteProvider = ({ children }) => {
  const [notesChanged, setNotesChanged] = useState(false);
  const resetNotesChanged = () => setNotesChanged(false);
  return (
    <NoteContext.Provider
      value={{ notesChanged, setNotesChanged, resetNotesChanged }}
    >
      {children}
    </NoteContext.Provider>
  );
};
